import { Modal, Input, Select, message, Button } from 'antd';
import React, { FC, useState, useEffect } from 'react';
import { getProductId } from '@/infrastructure/product-info';
import { TapdParams } from '@/presentation/components/tapd';
import { bindTapdIssue } from '@/presentation/components/tapd/api';
import { useStores } from '@/presentation/store';
import { FilterOptions } from '@/proto/alert';
import { Zone } from '@/proto/field';
import style from './index.module.scss';
import { useTranslation } from 'react-i18next';

interface IPros {
  visible: boolean;
  bindParams: TapdParams;
  onHide: () => void;
  onSubmit: () => void;
}

/**
 * 关联缺陷单组件
 */

export const BindTapdModal: FC<IPros> = (props) => {
  const { t } = useTranslation();
  const { visible, bindParams, onHide, onSubmit } = props;
  const [tapdLists, setTapdLists] = useState<FilterOptions[]>([]);
  const [tapdId, setTapdId] = useState('');
  const [workspaceId, setWorkspaceId] = useState('');
  const { tapdList } = useStores().TapdStore;
  const [loading, setLoading] = useState(false);

  const getBugIdFromUrl = (url: string) => {
    const params = url?.split('?')[1]?.split('&') || url?.split('/')?.slice(-1)?.[0];
    if (params) {
      const paramsObj: Record<string, any> = {};
      for (const param of params) {
        const [key, value] = param?.split('=');
        paramsObj[key] = value;
      }
      return paramsObj?.bug_id ?? params;
    }
    return undefined;
  };

  const updateTapd = async () => {
    if (!workspaceId) {
      message.warning(t("请选择需要关联的Tapd项目"));
      return;
    }
    if (!tapdId) {
      message.warning(t("请输入需要关联的缺陷单id"));
      return;
    }
    setLoading(true);
    const succ = await bindTapdIssue({
      appID: getProductId(),
      type: Zone.Bugly,
      issueUUID: bindParams.issueKey,
      tapdID: getBugIdFromUrl(tapdId) ?? tapdId,
      workSpaceID: workspaceId,
    });

    setLoading(false);
    if (succ?.retStatus === 0) {
      message.success(t("关联成功"));
    } else {
      message.error(succ?.msg ?? t("未知错误"));
      return;
    }
    onSubmit();
    onHide();
  };

  useEffect(() => {
    const list: FilterOptions[] = [];
    tapdList.forEach((item) => {
      if (item.workspaceName && item.workspaceId) {
        list.push({ label: item.workspaceName, value: item.workspaceId });
      }
    });
    setTapdLists(list);
  }, [tapdList]);

  return (<Modal
    centered
    title={t("关联缺陷单")}
    footer={null}
    visible={visible}
    onOk={() => updateTapd()}
    onCancel={() => onHide()}
    className={style.bindModal}
  >
    <div style={{ display: 'flex', marginBottom: '20px', width: '380px', lineHeight: '30px' }}>
      <span style={{ width: '80px', textAlign: 'right', marginRight: '8px' }}>
        {t("Tapd项目：")}
      </span>
      <Select
        placeholder={t("请选择TAPD项目")}
        options={tapdLists}
        style={{ width: '300px' }}
        onChange={(changeValue: string) => setWorkspaceId(changeValue)}
      />
    </div>
    <div style={{ display: 'flex', marginBottom: '20px', width: '380px', lineHeight: '30px' }}>
      <span style={{ width: '80px', textAlign: 'right', marginRight: '8px' }}>
        {t("缺陷单：")}
      </span>
      <Input
        placeholder={t("请输入需要关联的缺陷单的ID或者链接")}
        required={true}
        style={{ width: '300px' }}
        onChange={(e: any) => setTapdId(e.target.value)}
      />
    </div>
    <div style={{ textAlign: 'right' }}>
      <Button
        type='primary'
        loading={loading}
        onClick={() => {
          updateTapd();
        }}
        style={{ marginLeft: '20px' }}>
        {t("确定")}
      </Button>
    </div>
  </Modal>);
};
